<footer class="text-justify p-4 md:p-8 lg:p-12" style="padding-top:0!important">
  <div class="container mx-auto" [innerHTML]="footerTextElement | safe: 'html'"></div>
</footer>
